/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "566")
  

// 接口文档

  
    
export type IAPI77418ResDataObj = {};
    
  



export interface API77418Req {
  
  /** 事件编码 */
  eventCode: string;
  /** 运行参数 */
  runParam: string;
};



export interface API77418Res {
  /** Object  */
  data?: IAPI77418ResDataObj;
  
};


// 接口函数 77418 事件执行

export interface IUsePostAPI77418Return {
  /** 事件执行: 接口请求状态 */
  isAPI77418Loading: boolean;
  /** 事件执行: 接口请求返回数据 */
  dataAPI77418: API77418Res;
  /**  事件执行: 接口数据请求方法 */
  fetchAPI77418Data: (inputs: API77418Req, config?: YWRequestConfig) => Promise<API77418Res>;
  /** 事件执行: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI77418 = ():IUsePostAPI77418Return => {
  let isMount = true;
  const [isAPI77418Loading, setIsAPI77418Loading] = useState(false);
  const [dataAPI77418, setDataAPI77418] = useState<API77418Res>({} as API77418Res);
  const requestUrl = `${basePath}/yoaichat-admin/event/execute`;

  const fetchAPI77418Data = async (inputs: API77418Req, config?: YWRequestConfig): Promise<API77418Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API77418Req>) || {}) as API77418Req;
    
  
    if ( isMount ) {
      setIsAPI77418Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API77418Res>(`${basePath}/yoaichat-admin/event/execute`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI77418(res || {} as API77418Res);
        setIsAPI77418Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI77418Loading(false);
      }
      return false as unknown as API77418Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI77418Loading,
    dataAPI77418,
    fetchAPI77418Data,
    requestUrl,
  }
}

